//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.BoundarySet.js";
import "../no/ugmath.js";
let d=[[[0,"ControlPoints",0,"CAM.WedmCustomBoundaryDataBuilder",0],[0,"CustomStock",1,0],[0,"CustomTaperAngle",1,0],[0,"CustomTolerances",1,0],[0,"InTolerance",1,0],[0,"OutTolerance",1,0],[0,"Stock",1,0],[0,"TaperAngle",1,0]],[[[],"CreateBoundaryMemberSetWireEdm",{R_:{bndSet:"CAM.BoundaryMemberSetWireEDM"}},0,0],[["face","pickPoint"],"AddTopFace",{},2,0],[["faces","pickPoint"],"AppendSideFaces",{},2,0],[["face"],"RemoveSideFace",{},1,0],[["curves","pickPoint","matrix"],"AppendCurvesToWireframe",{},3,0],[["curves"],"RemoveCurvesFromWireframe",{},1,0]],[]];
SPLM.CAM.BoundarySetWireEDM = class extends SPLM.CAM.BoundarySet{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.BoundarySetWireEDM";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;